import { useEffect, useState } from "react"
import FilterLayout from "../../layouts/FilterLayout"
import { Column, Row } from "../../../styles/TableStyle"
import { FlexCenter } from "../../../styles/CommonStyles"
import { SOCKET_URL } from "../../../core/constants/urls"
import { formatNumber } from "../../../core/utils/common"
import { useSwapHistoryQuery } from "../../../core/services/react-query/swap"
import MobileModal from "../../modals/MobileModal"
import SwapHistoryDetailsModal from "./SwapDetailsModal"

const initialModalState = { show: false, data: null }

const RSwapHistoryTable = () => {

    const [modal, setModal] = useState(initialModalState)
    const onCloseModal = () => setModal(initialModalState)

    const initialState = {
        page: 1,
        dateFrom: null,
        search: {
            fromCurrency: "fromCurrency",
            toCurrency: "toCurrency",
        },
        query: {
            fromCurrency: "",
            toCurrency: "",
        },
    }

    const [filterQueries, setFilterQueries] = useState(initialState)
    const [allPages, setAllPages] = useState(null)

    const { data: orders, isFetching, refetch } = useSwapHistoryQuery(filterQueries)

    useEffect(() => {
        if ((orders && !allPages) || (orders && orders.meta.total !== allPages)) {
            setAllPages(orders.meta.total)
        }
        // eslint-disable-next-line
    }, [orders])

    useEffect(() => {
        refetch()
    }, [filterQueries, refetch])

    return (
        <FilterLayout
            headers={headers}
            data={orders}
            totalPages={allPages}
            state={{ filterQueries, setFilterQueries, initialState }}
            loading={isFetching}
        >
            {orders?.data?.map((item) => (
                <Row key={item._id} onClick={() => { setModal({ show: true, data: item }) }}>
                    {/* Currency: from → to */}
                    <Column width="33.33%">
                        <FlexCenter className="gap-1">
                            <img
                                src={SOCKET_URL + `assets/icon/${item.fromCurrency}.png`}
                                alt={item.fromCurrency}
                                width="18px"
                                height="18px"
                            />
                            {/* <span className="uppercase">{item.fromCurrency}</span> */}
                            <span className="mx-1">→</span>
                            <img
                                src={SOCKET_URL + `assets/icon/${item.toCurrency}.png`}
                                alt={item.toCurrency}
                                width="18px"
                                height="18px"
                            />
                            {/* <span className="uppercase">{item.toCurrency}</span> */}
                        </FlexCenter>
                    </Column>

                    {/* amount */}
                    <Column width="33.33%" number>
                        {formatNumber(item.amount)}
                    </Column>

                    {/* toAmount */}
                    <Column width="33.33%" number>
                        {formatNumber(item.toAmount)}
                    </Column>
                </Row>
            ))}
            <MobileModal isOpen={modal.show} onClose={onCloseModal}>
                <SwapHistoryDetailsModal data={modal.data} onClose={onCloseModal} />
            </MobileModal>
        </FilterLayout>
    )
}

const headers = [
    { title: "currency", width: "33.33%" },
    { title: "amount", width: "33.33%" },
    { title: "to-amount", width: "33.33%" },
]

export default RSwapHistoryTable
